/**
 * V2 Kbd — keyboard hint chip from design_reference (`.kbd`).
 */

import type { ReactNode } from 'react';
import { cn } from '../../../lib/utils';

/** Props for the V2 Kbd. */
export interface KbdProps {
  children: ReactNode;
  className?: string;
}

/** V2 keyboard shortcut chip. */
export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={cn(
        'font-[var(--font-mono)] text-[10.5px] text-[var(--tx-lo)]',
        'border border-[var(--bd)] rounded-[4px] px-[5px] py-px',
        'bg-[var(--bg-2)] shadow-[inset_0_-1px_0_var(--bd)]',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
